/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespSimilarItem_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSimilarItemsGridSeller_viewer$ref: FragmentReference;
export type PdpRespSimilarItemsGridSeller_viewer = {|
  +$fragmentRefs: PdpRespSimilarItem_viewer$ref,
  +$refType: PdpRespSimilarItemsGridSeller_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsGridSeller_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b2ac9e95e218aa71d2752773c7d8b309';
module.exports = node;
